/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { EsercenteProfiloCreationForm } from '../model/esercente-profilo-creation-form';
// @ts-ignore
import { EsercenteProfiloListFilter } from '../model/esercente-profilo-list-filter';
// @ts-ignore
import { EsercenteProfiloSchedaDTO } from '../model/esercente-profilo-scheda-dto';
// @ts-ignore
import { EsercenteProfiloUpdateForm } from '../model/esercente-profilo-update-form';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GenericResponseDTO } from '../model/generic-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelEsercentePraticaBackofficeRowDTO } from '../model/paged-model-esercente-pratica-backoffice-row-dto';
// @ts-ignore
import { PagedModelEsercenteProfiloRowDTO } from '../model/paged-model-esercente-profilo-row-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EsercentiSchedaServiceInterface,
    CreaProfiloEsercenteBackofficeRequestParams,
    GetProfiloEsercenteBackofficeRequestParams,
    ListPraticheProfiloEsercenteBackofficeRequestParams,
    ListProfiliEsercenteBackofficeRequestParams,
    ReinviaAttivazioneProfiloEsercenteBackofficeRequestParams,
    UpdateProfiloEsercenteBackofficeRequestParams
} from './esercenti-scheda.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EsercentiSchedaService extends BaseService implements EsercentiSchedaServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Crea un esercente con email di attivazione.
     * Crea utente ESERCENTE e profilo; l\&#39;esercente riceve l\&#39;email di attivazione (testo \&#39;creato da un operatore\&#39;). OP_COMUNE: comune_riferimento_id obbligatorio e tra i suoi (422); SUPERADMIN: facoltativo. P.IVA gia\&#39; registrata: 400 esercente_partita_iva_gia_registrata (senza dati dell\&#39;esistente); email gia\&#39; registrata: 400.
     * @endpoint post /api/v1/gestione/esercenti/profili
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public creaProfiloEsercenteBackoffice(requestParameters: CreaProfiloEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsercenteProfiloSchedaDTO>;
    public creaProfiloEsercenteBackoffice(requestParameters: CreaProfiloEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsercenteProfiloSchedaDTO>>;
    public creaProfiloEsercenteBackoffice(requestParameters: CreaProfiloEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsercenteProfiloSchedaDTO>>;
    public creaProfiloEsercenteBackoffice(requestParameters: CreaProfiloEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const esercenteProfiloCreationForm = requestParameters?.esercenteProfiloCreationForm;
        if (esercenteProfiloCreationForm === null || esercenteProfiloCreationForm === undefined) {
            throw new Error('Required parameter esercenteProfiloCreationForm was null or undefined when calling creaProfiloEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsercenteProfiloSchedaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: esercenteProfiloCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scheda di un esercente.
     * Dati d\&#39;impresa, email, stato account, comune di riferimento, conteggi di negozi, cassieri e domande (queste ultime solo su bandi visibili al chiamante) e version per il PUT. 404 se inesistente o fuori perimetro.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getProfiloEsercenteBackoffice(requestParameters: GetProfiloEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsercenteProfiloSchedaDTO>;
    public getProfiloEsercenteBackoffice(requestParameters: GetProfiloEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsercenteProfiloSchedaDTO>>;
    public getProfiloEsercenteBackoffice(requestParameters: GetProfiloEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsercenteProfiloSchedaDTO>>;
    public getProfiloEsercenteBackoffice(requestParameters: GetProfiloEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling getProfiloEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsercenteProfiloSchedaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Domande di un esercente sui bandi visibili al chiamante.
     * Paginate, piu\&#39; recenti prima (il sort e\&#39; ignorato). OP_COMUNE: solo i bandi dei suoi comuni. 404 se l\&#39;esercente e\&#39; fuori perimetro.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/pratiche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listPraticheProfiloEsercenteBackoffice(requestParameters: ListPraticheProfiloEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelEsercentePraticaBackofficeRowDTO>;
    public listPraticheProfiloEsercenteBackoffice(requestParameters: ListPraticheProfiloEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelEsercentePraticaBackofficeRowDTO>>;
    public listPraticheProfiloEsercenteBackoffice(requestParameters: ListPraticheProfiloEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelEsercentePraticaBackofficeRowDTO>>;
    public listPraticheProfiloEsercenteBackoffice(requestParameters: ListPraticheProfiloEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling listPraticheProfiloEsercenteBackoffice.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listPraticheProfiloEsercenteBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelEsercentePraticaBackofficeRowDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata degli esercenti nel proprio perimetro.
     * SUPERADMIN: tutti. OP_COMUNE: esercenti con comune di riferimento tra i suoi comuni o con almeno una domanda su un bando di un suo comune. Filtri: q (ragione sociale, P.IVA, email), partita_iva, comune_riferimento_id, stato. numero_domande conta solo le domande su bandi visibili al chiamante. Sort ammessi: ragione_sociale (default), partita_iva, email.
     * @endpoint get /api/v1/gestione/esercenti/profili
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listProfiliEsercenteBackoffice(requestParameters: ListProfiliEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelEsercenteProfiloRowDTO>;
    public listProfiliEsercenteBackoffice(requestParameters: ListProfiliEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelEsercenteProfiloRowDTO>>;
    public listProfiliEsercenteBackoffice(requestParameters: ListProfiliEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelEsercenteProfiloRowDTO>>;
    public listProfiliEsercenteBackoffice(requestParameters: ListProfiliEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listProfiliEsercenteBackoffice.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listProfiliEsercenteBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelEsercenteProfiloRowDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reinvia l\&#39;email di attivazione a un esercente.
     * Solo se l\&#39;account non e\&#39; ancora attivato (invito in attesa): account bloccato dall\&#39;amministrazione, gia\&#39; attivo o sospeso → 422. Il token dell\&#39;invito e\&#39; riusato. Nessun link manuale.
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/reinvia-attivazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public reinviaAttivazioneProfiloEsercenteBackoffice(requestParameters: ReinviaAttivazioneProfiloEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public reinviaAttivazioneProfiloEsercenteBackoffice(requestParameters: ReinviaAttivazioneProfiloEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public reinviaAttivazioneProfiloEsercenteBackoffice(requestParameters: ReinviaAttivazioneProfiloEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public reinviaAttivazioneProfiloEsercenteBackoffice(requestParameters: ReinviaAttivazioneProfiloEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling reinviaAttivazioneProfiloEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/reinvia-attivazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica i dati di un esercente.
     * PUT-replace dei dati d\&#39;impresa (stesse regole del self-service, P.IVA inclusa) e del comune di riferimento, con optimistic lock (version stale: 409). SUPERADMIN: comune libero e annullabile. OP_COMUNE: solo se il comune di riferimento dell\&#39;esercente e\&#39; uno dei suoi (altrimenti 403 esercente_dati_non_modificabili; la scheda espone puo_modificare_dati), sceglie solo tra i suoi comuni e non lo annulla (422). P.IVA in collisione: 400.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateProfiloEsercenteBackoffice(requestParameters: UpdateProfiloEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EsercenteProfiloSchedaDTO>;
    public updateProfiloEsercenteBackoffice(requestParameters: UpdateProfiloEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EsercenteProfiloSchedaDTO>>;
    public updateProfiloEsercenteBackoffice(requestParameters: UpdateProfiloEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EsercenteProfiloSchedaDTO>>;
    public updateProfiloEsercenteBackoffice(requestParameters: UpdateProfiloEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling updateProfiloEsercenteBackoffice.');
        }
        const esercenteProfiloUpdateForm = requestParameters?.esercenteProfiloUpdateForm;
        if (esercenteProfiloUpdateForm === null || esercenteProfiloUpdateForm === undefined) {
            throw new Error('Required parameter esercenteProfiloUpdateForm was null or undefined when calling updateProfiloEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<EsercenteProfiloSchedaDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: esercenteProfiloUpdateForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
